<template>
<div class="container">
  <div class="col-md-12">
    <div v-if="isProductLoading" class="text-center">
      <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize" class="d-inline-block" />
    </div>

    <div v-else class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-4 offset-md-4">
          <div class="intrinsic">
            <img class="img-fluid intrinsic-item" :src="item.picUrl" alt="">
          </div>
        </div>
      </div>
      <br>
      <div class="caption-full">
        <h6 class="pull-right">$ {{ item.price }}</h6>
        <h4> {{ item.title }}</h4>
        <p> {{ item.description }} </p>
      </div>
      <div class="ratings">
        <p class="pull-left">
          <button class="btn btn-success" @click="showProducts()">
              <i class="fa fa-angle-left d-inline"></i> Back
          </button>
        </p>
        <p class="pull-right">
          <button :disabled="isLoggedIn==false" @click="addItem" class="btn btn-success">Add to cart</button>
        </p>
        <div class="clearfix"></div>
      </div>
    </div>
    </div>

  </div>

</div>

</template>

<script>
import {
  mapActions,
  mapGetters
} from 'vuex';
import GridLoader from 'vue-spinner/src/GridLoader.vue';

export default {
  components: {
    GridLoader
  },
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px",
    }
  },
  computed: {
    ...mapGetters(['isLoggedIn', 'isProductLoading', 'orgId', 'itemLevel', 'items1', 'items2', 'curItem1']),

    products(){
      if (this.itemLevel==1)
        return(this.items1)
      else
        return(this.items2)
    },

    item() {
      let id = this.$route.params.id;
      if (this.products.length >= id) {
        let filterArr = this.products.filter((item) => {
          return item.id == id
        });
        if (filterArr.length > 0) {
          return filterArr[0];
        }
      }
      return {};
    }
  },
  methods: {
    ...mapActions(['updateCart', 'setItemLevel']),

    showProducts() {
      var itemLevel = 2
      this.setItemLevel({itemLevel})
      this.$router.push('/' + this.orgId)
    },

    addItem() {
      const order = {
        item: Object.assign({}, this.item),
        price: this.item.price,
        discount: 0,
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    }
  }
}
</script>

<style scoped>
.caption-full {
  padding-right: 10px;
  padding-left: 10px;
}

.ratings {
  padding-right: 10px;
  padding-left: 10px;
  color: #d17581;
}
</style>
